module.exports = __webpack_public_path__ + "static/media/pump-circle-green.d98685f2.png";